var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflowTop"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"赊账列表","name":"credit-index"}}),_c('el-tab-pane',{attrs:{"label":"总还款记录","name":"credit-record"}})],1),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }